if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Core elements
        this.form = this.querySelector('form');
        if (!this.form) {
          console.warn('[product-form] No <form> found');
          return;
        }

        // 🔥 IMPORTANT: force MINI-CART only
        this.cart = document.querySelector('mini-cart');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span') || this.submitButton
          : null;

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Enable variant input
        const vid = this.variantIdInput;
        if (vid) vid.disabled = false;

        // Bind submit
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this.onSubmitHandler);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');

        const config = fetchConfig ? fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Sections for MINI-CART only
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }

        config.body = formData;

        fetch(theme.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            // Shopify error
            if (response.status) {
              publish?.(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            // No mini-cart → fallback
            if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            // Success
            publish?.(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('[product-form] add to cart failed:', e);
          })
          .finally(() => {
            this.submitButton?.classList.remove('loading');
            if (this.cart?.classList?.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton?.removeAttribute('aria-disabled');
            }
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        const requiredFields = this.form.querySelectorAll('[required]');
        if (!requiredFields.length) return true;

        let allFilled = true;

        requiredFields.forEach((field) => {
          let valid = true;

          if (field.type === 'checkbox' || field.type === 'radio') {
            const group = this.form.querySelectorAll(`[name="${field.name}"]`);
            valid = [...group].some((i) => i.checked);
          } else {
            valid = field.value.trim() !== '';
          }

          field.classList.toggle('invalid', !valid);
          if (!valid) allFilled = false;
        });

        if (!allFilled) {
          this.handleErrorMessage(
            theme?.accessibilityStrings?.fillInAllLineItemPropertyRequiredFields ||
              'Please fill all required fields.'
          );
        }

        return allFilled;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
